import type { NotificationSettings } from '../../types';

interface NotificationsSectionProps {
  notifications: NotificationSettings;
  onChange: (field: keyof NotificationSettings, value: string | boolean) => void;
}

function NotificationsSection({ notifications, onChange }: NotificationsSectionProps) {
  return (
    <div className="form-section">
      <h2>Notifications</h2>
      <p className="section-description">Configure email notifications and tracking updates.</p>

      <div className="form-grid-settings">
        <div className="form-group full-width">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={notifications.email_notifications}
              onChange={(e) => onChange('email_notifications', e.target.checked)}
            />
            Enable email notifications
          </label>
          <p className="field-hint">Receive email alerts for shipment updates and errors.</p>
        </div>

        <div className="form-group full-width">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={notifications.send_tracking_emails}
              onChange={(e) => onChange('send_tracking_emails', e.target.checked)}
            />
            Send tracking emails to recipients
          </label>
          <p className="field-hint">Automatically send tracking information to recipients after label purchase.</p>
        </div>

        <div className="form-group">
          <label htmlFor="tracking-template">Tracking Email Template</label>
          <select
            id="tracking-template"
            value={notifications.tracking_email_template}
            onChange={(e) => onChange('tracking_email_template', e.target.value)}
          >
            <option value="default">Default Template</option>
            <option value="minimal">Minimal</option>
            <option value="detailed">Detailed</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default NotificationsSection;
